import { Box, Flex, Text, Icon, Grid, HStack } from "@chakra-ui/react";
import { ChartColumn } from "lucide-react";
import { IoMdCart } from "react-icons/io";
import { GoPackage } from "react-icons/go";
import { MdLocalShipping, MdCancel } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import { ROTULO_SECAO, COR_ROTULO, SOMBRA, NUMEROS } from "../VendaCardV2/ui";

const statusList = [
    { label: "Confirmadas", value: "confirmadas", color: "gray.700", bg: "gray.100", icon: IoMdCart, textColor: "gray.800" },
    { label: "Para Enviar", value: "enviar", color: "yellow.800", bg: "yellow.100", icon: GoPackage, textColor: "yellow.900" },
    { label: "Em Trânsito", value: "transito", color: "blue.700", bg: "blue.100", icon: MdLocalShipping, textColor: "blue.900" },
    { label: "Concluídas", value: "concluidas", color: "green.700", bg: "green.100", icon: FaCheckCircle, textColor: "green.900" },
    { label: "Canceladas", value: "canceladas", color: "red.700", bg: "red.100", icon: MdCancel, textColor: "red.900" },
];

function formatarDataParaBR(dataISO) {
    if (!dataISO) return "";
    const [ano, mes, dia] = dataISO.split("-");
    return `${dia}/${mes}/${ano}`;
}

export default function StatusVendasMktplaces({ totalVendas, totalVendasTAGA, data_inicio, data_fim, dataUltimaAtualizacaoVendas, v2 }) {
    if (v2) {
        return (
            <Box w="100%" mt={2} px={{ base: 3, md: 4 }} py={3} bg="white" border="1px solid" borderColor="gray.200" borderRadius="xl" boxShadow={SOMBRA} textAlign="left">
                <Flex align="center" justify="space-between" columnGap={3} rowGap={1} wrap="wrap" mb={2.5}>
                    <HStack spacing={1.5} color={COR_ROTULO}>
                        <Icon as={ChartColumn} boxSize="13px" strokeWidth={2.25} />
                        <Text {...ROTULO_SECAO}>Status vendas</Text>
                    </HStack>
                    <Text fontSize="11px" color="gray.500" sx={NUMEROS}>
                        {totalVendasTAGA.total_vendas} venda(s) · {formatarDataParaBR(data_inicio)} a {formatarDataParaBR(data_fim)} · Atualizado {dataUltimaAtualizacaoVendas}
                    </Text>
                </Flex>
                <Grid templateColumns={{ base: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", lg: "repeat(5, minmax(0, 1fr))" }} gap={2}>
                    {statusList.map((status, i) => (
                        <Flex key={status.value} align="center" gap={2.5} px={3} py={2} minW={0} borderRadius="lg" border="1px solid" borderColor="gray.200" borderLeft="3px solid" borderLeftColor={status.color} bg="gray.50"
                            gridColumn={{ base: i === statusList.length - 1 ? "span 2" : "auto", sm: "auto" }}>
                            <Flex flex="none" w="30px" h="30px" borderRadius="md" bg={status.bg} color={status.color} align="center" justify="center">
                                <Icon as={status.icon} boxSize="15px" />
                            </Flex>
                            <Box minW={0}>
                                <Text fontSize="17px" fontWeight="800" color="gray.900" lineHeight="1.15" sx={NUMEROS}>{totalVendas[status.value]}</Text>
                                <Text fontSize="11px" fontWeight="500" color="gray.500">{status.label}</Text>
                            </Box>
                        </Flex>
                    ))}
                </Grid>
            </Box>
        );
    }

    return (
        <Box w="100%" mx="auto" mt={4} px={{ base: 2, md: 4 }} pt={3} pb={2} borderRadius="lg" boxShadow="md" bg="gray.50" border="1px solid #FF9F59">
            <Flex align="center" mt={-5} mb={1.5} px={1}>
                <Text
                    fontSize="8px"
                    color="#F68633"
                    fontWeight="bold"
                    bg="white"
                    w="80px"
                    px={1}
                    borderRadius="md"
                    border="1px solid #FF9F59"
                    textAlign="center"
                    lineHeight="14px"
                >
                    STATUS VENDAS
                </Text>
            </Flex>

            <Flex wrap="wrap" gap={2} justify="center" pb={1} px={{ base: 0, md: 2 }}>
                {statusList.map((status) => (
                    <Box
                        key={status.value}
                        bg={status.bg}
                        color={status.textColor}
                        rounded="lg"
                        boxShadow="sm"
                        px={3}
                        py={2}
                        minW={{ base: "100%", sm: "140px", md: "120px" }}
                        textAlign="center"
                        border="1px solid"
                        borderColor={status.color}
                    >
                        <Flex align="center" justify="center" gap={2}>
                            <Icon as={status.icon} boxSize="18px" color={status.color} />
                            <Text fontWeight="bold" fontSize="13px">
                                {totalVendas[status.value]}
                            </Text>
                            <Text fontSize="12px" color={status.color}>
                                {status.label}
                            </Text>
                        </Flex>
                    </Box>
                ))}
            </Flex>

            <Text fontSize="9px" color="gray.400" textAlign="center" mt={1} pb={1}>
                {totalVendasTAGA.total_vendas} venda(s) de {formatarDataParaBR(data_inicio)} a {formatarDataParaBR(data_fim)} — Atualizado {dataUltimaAtualizacaoVendas}
            </Text>
        </Box>
    );
}
